module.exports = __webpack_public_path__ + "img/dsh4.84870d44.jpg";